// One strict YYYY-MM-DD validator for every date control that reaches a wire.
//
// Pickers only emit this shape, but saved searches, playbook audiences, ?q=
// links and agent-authored filters carry anything. The provider treats an
// unparseable date as NO constraint, so a bad value used to vanish and BROADEN
// the query; it now fails closed through F10's typed compile error.

import { FilterCompileError } from '@/utils/filter-compile-error.util';

const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

/**
 * Return the trimmed ``YYYY-MM-DD`` value, or throw ``FilterCompileError``.
 *
 * Calendar-real, not just well-shaped: ``2026-02-31`` and ``2026-13-01`` are
 * rejected, because the provider would silently drop them.
 */
export function normalizeCalendarDate(
  value: string,
  field: string,
  label: string
): string {
  const trimmed = value.trim();
  const match = ISO_DATE.exec(trimmed);
  if (match) {
    const [, y, m, d] = match;
    const parsed = new Date(`${trimmed}T00:00:00Z`);
    // Round-trip through Date so an overflowing day (Feb 31 -> Mar 3) fails.
    if (
      !Number.isNaN(parsed.getTime()) &&
      parsed.getUTCFullYear() === Number(y) &&
      parsed.getUTCMonth() + 1 === Number(m) &&
      parsed.getUTCDate() === Number(d)
    ) {
      return trimmed;
    }
  }
  throw new FilterCompileError(
    field,
    label,
    `"${value}" is not a valid YYYY-MM-DD date.`
  );
}
